<template>
    <div class="mx-auto mt-5">
        <div id="header-identificacao" class="row bg-light mb-2">
            <div class="col-sm-12 col-md-6">
                <fieldset class="form-group">
                    <div role="group" class="bv-no-focus-ring">
                        <label for="cnpj">CNJ:</label>
                        <input id="cnpj" type="text" readonly="readonly" :value="cnj"
                               class="font-weight-bold form-control-plaintext">
                    </div>
                </fieldset>
            </div>
        </div>

        <div class="row center-xy">
            <div class="col-md-10">&nbsp;</div>
            <div class="text-right mb-3 col-md-2">
                <b-button class="finish-button" variant="success" @click="concluir">
                    Concluir
                    <i class="fas fa-flag-checkered"></i>
                </b-button>
            </div>
        </div>

        <div class="mx-auto">
            <b-row>
                <b-col sm="12" md="12">
                    <b-list-group>
                        <b-list-group-item class="flex-column align-items-start">
                            <div class="d-flex w-100 justify-content-between">
                                <h3 class="app-title mb-1">Requisição Criada com sucesso.</h3>
                            </div>
                            <ul v-if="requisicao.titularReceita == 0 && requisicao.procurador != null">
                                <li v-if="listaRequisicao.length > 1">
                                    Requisições <b>{{numeroRequisicoes()}}</b> {{nova ? 'criadas' : 'alteradas'}} com sucesso e aguardando validação pelo Procurador.
                                </li>
                                <li v-if="listaRequisicao.length == 1">
                                    Requisição <b>{{listaRequisicao[0]}}</b> {{nova ? 'criada' : 'alterada'}} com sucesso e aguardando validação pelo Procurador.
                                </li>
                            </ul>
                            <ul v-if="requisicao.titularReceita == 0 && requisicao.procurador == null && requisicao.formaPagamento == 1">
                                <li v-if="listaRequisicao.length > 1">
                                    Requisições <b>{{numeroRequisicoes()}}</b> {{nova ? 'criadas' : 'alteradas'}} com sucesso.
                                </li>
                                <li v-if="listaRequisicao.length == 1">
                                    Requisição <b>{{listaRequisicao[0]}}</b> {{nova ? 'criada' : 'alterada'}} com sucesso.
                                </li>
                            </ul>
                            <ul v-if="requisicao.titularReceita == 0 && requisicao.procurador == null && requisicao.formaPagamento == 2">
                                <li v-if="listaRequisicao.length > 1">
                                    Requisições <b>{{numeroRequisicoes()}}</b> {{nova ? 'geradas' : 'alteradas'}} com sucesso e aguardando validação pelo Tesoureiro do FEPGE e pelo GOFS.
                                </li>
                                <li v-if="listaRequisicao.length == 1">
                                    Requisição <b>{{listaRequisicao[0]}}</b> {{nova ? 'gerada' : 'alterada'}} com sucesso e aguardando validação pelo Tesoureiro do FEPGE e pelo GOFS.
                                </li>
                            </ul>
                            <ul v-if="requisicao.titularReceita == 1 && requisicao.formaPagamento === 3" >
                                <li>
                                    Requisição <b>{{numeroRequisicoes()}}</b> criada com sucesso e encaminhada à CES.
                                </li>
                            </ul>
                            <ul v-if="requisicao.titularReceita == 1 && requisicao.formaPagamento !== 3" >
                                <li>
                                    Requisição <b>{{numeroRequisicoes()}}</b> criada com sucesso.
                                </li>
                            </ul>
                        </b-list-group-item>
                        <b-list-group-item class="flex-column align-items-start" v-if="arquivoPdf != null">
                            <div class="d-flex w-100 justify-content-between">
                                <h3 class="app-title mb-1">Requisição Criada</h3>
                            </div>
                            <embed :src="`${urlApi}/v1/honorariosAcaoJudicial/obterArquivoRequisicao/publico/${listaRequisicao[0]}/${arquivoPdf}`"
                                    type="application/pdf"
                                    width="100%"
                                    height="400px"/>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: ['cnj', 'listaRequisicao', 'nova', 'requisicao','arquivoPdf'],
        data() {
            return {
                urlApi: null,
                urlPdf: null,
            }
        },
        methods: {
            concluir() {
                this.$router.push({path: '/honorarios'});
            },
            numeroRequisicoes() {
                let numeros = "";
                for(var i = 0; i < this.listaRequisicao.length; i++) {
                    if((i + 1) == this.listaRequisicao.length && this.listaRequisicao.length > 1) {
                        numeros += " e ";
                    } else if(i > 0) {
                        numeros += ", ";
                    }
                    numeros += this.listaRequisicao[i];
                }
                return numeros;
            },
        },
        mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
        }
    }
</script>
<style>
</style>
